import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import DeptInfo from '../../components/deptmng/DeptInfo';
import DeptAddFormContainer from './DeptAddFormContainer';
import DeptEmpListContainer from './DeptEmpListContainer';

import _ from 'lodash';

const DepartViewContainer = () => {
  const { depart, baseCodes } = useSelector(({ departModule, auth }) => ({
    depart: departModule.depart.depart,
    baseCodes: auth.baseCodes,
  }));

  const [checkedRoles, setCheckedRoles] = useState([]);

  useEffect(() => {
    if (depart && baseCodes && !_.isEmpty(depart?.roleList)) {
      // const rolekeys = _.keys(depart.roleList);
      const filteredList = _.filter(baseCodes, {
        blcCd: 'BASE',
        mlcCd: 'DPT',
        slcCd: 'PROPERTY',
      });

      let roleList = [];
      _.forEach(filteredList, (item) => {
        if (depart.roleList[item.revVal1] === 'Y') {
          roleList.push(item.revVal2);
        }
      });
      setCheckedRoles(roleList);
    }
  }, [depart.roleList]);

  return (
    <>
      <DetailTemplate title="기본 정보">
        <DeptInfo depart={depart} checkedRoles={checkedRoles} />
      </DetailTemplate>
      <DetailTemplate title="부서 사원리스트">
        <DeptEmpListContainer depart={depart} />
      </DetailTemplate>
      <DeptAddFormContainer depart={depart} />
    </>
  );
};

export default DepartViewContainer;
